import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=5d71e58e&scoped=true"
import script from "./DocumentType.vue?vue&type=script&lang=js"
export * from "./DocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71e58e",
  null
  
)

export default component.exports